import { render, staticRenderFns } from "./MaterialsHistory.vue?vue&type=template&id=16936b6d&scoped=true"
import script from "./MaterialsHistory.vue?vue&type=script&lang=js"
export * from "./MaterialsHistory.vue?vue&type=script&lang=js"
import style0 from "./MaterialsHistory.vue?vue&type=style&index=0&id=16936b6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16936b6d",
  null
  
)

export default component.exports